import apiCall from '../index'

const apiProyectoUsuarioService = '/gsencuesta/api/v1/proyecto_usuario'

const service = {
  findAllByProyecto(params) { // OPTIMIZAR// agregar en otro action
    return new Promise((resolve, reject) => {
      apiCall
        .get(`${apiProyectoUsuarioService}/proyecto/${params.idProyecto}`)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  create(model) {
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .post(apiProyectoUsuarioService, model)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
  deleteAll(model) {
    const authorization = 'Authorization'
    return new Promise((resolve, reject) => {
      apiCall
        .defaults
        .headers
        .common[authorization] = `${localStorage.getItem('token-type')} ${localStorage.getItem('user-token')}`
      apiCall
        .post(`${apiProyectoUsuarioService}/delete`, model)
        .then(res => resolve(res.data))
        .catch(err => reject(err))
    })
  },
}

export default service
